import React, { useState, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { makeStyles } from '@mui/styles';
import LinkIcon from '../../icons/Link';
import QuickLinksPopover from './QuickLinksPopover';

const useStyles = makeStyles({
    iconButton: {
        cursor: 'pointer',
    },
});

interface LinksWidgetProps {
    disabled?: boolean;
}

const LinksWidget: React.FC<LinksWidgetProps> = ({ disabled = false }) => {
    const classes = useStyles();
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState<boolean>(false);

    const handleIconClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (disabled) {
        return null;
    }

    return (
        <>
            <Tooltip title="Quick Links" arrow>
                <IconButton
                    ref={anchorRef}
                    onClick={handleIconClick}
                    className={classes.iconButton}
                    size='small'
                    sx={{
                        color: '#718096',
                        borderRadius: '8px',
                        transition: 'background-color 150ms ease, color 150ms ease',
                        '&:hover': {
                            backgroundColor: 'rgba(113, 128, 150, 0.12)',
                            color: '#4A5568',
                        },
                    }}
                >
                    <LinkIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <QuickLinksPopover
                anchorEl={anchorRef.current}
                open={open}
                onClose={handleClose}
            />
        </>
    );
};

export default LinksWidget;
